import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import { AnyValue } from '@shared/types/any-value.type';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  ROUTE_API = 'connect/userinfo';
  ROUTE_API_USERS_EMAIL = 'api/v1/users/{email}/id';
  ROUTE_API_GET_USER_ID = 'api/v1/users/{id}';

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly configService: ConfigurationService,
  ) {}

  public getUserInfo() {
    return this.httpClient.get<AnyValue>(`${this.configService.authentication?.issuer}/${this.ROUTE_API}`).pipe(
      map((result: AnyValue) => {
        return {
          sub: result.sub,
          name: result.name,
          given_name: result.given_name,
          family_name: result.family_name,
          role: result.role,
          deskPhoneNumber: result['http://login.schemas.ebp.com/identity/claims/DeskPhoneNumber'],
          email: result.email,
          phone_number: result.phone_number,
        };
      }),
    );
  }
}
